import moment from 'moment';

export default {
  data: () => ({
    readNotifications: [],
  }),
  methods: {
    async readNotification(notification) {
      if (notification.read_at) {
        return;
      }
      await this.$store.dispatch('frontend/user/readNotification', notification.id);
      this.readNotifications.push(notification.id);
    },
    notificationDate(notification) {
      return moment(notification.created_at).format("YYYY年M月D日");
    },
    proposalCommentMention({ user, proposal, content }) {
      const url = proposal.is_todo
      ? `/todo/detail/${proposal.id_encrypt}`
      : `/proposals/detail/${proposal.id_encrypt}`;

      return `${user.full_name}がコメントをしました：${content}　ー<a href="${url}">${proposal.title}</a>`;
    },
    documentCommentMention({ user, documentId, content, documentName }) {
      const url = `/document/detail/${documentId}`;

      return `${user.full_name}がコメントをしました：${content}　ー<a href="${url}">${documentName}</a>`;
    },
    proposalCreated(data) {
      const proposal = data.proposal;
      const url = proposal.is_todo
          ? `/todo/detail/${proposal.id_encrypt}`
          : `/proposals/detail/${proposal.id_encrypt}`;

      return `<a href="${url}">${proposal.title}</a>を作成しました`;
    },
    proposalDeleted(data) {
      const proposal = data.proposal;
      if (proposal.is_todo) {
        return `この${proposal.title}は削除されています。`;
      }
    },
    todoAlarmAt({ todo }) {
      const url = `/todo/detail/${todo.id_encrypt}`;
      return `Todoの通知日です　ー<a href="${url}">${todo.title}</a>`;
    },
    stepAssigned(data) {
      const step = data.step;
      const proposal = step.proposal;
      const url = proposal.is_todo
          ? `/todo/detail/${proposal.id_encrypt}`
          : `/proposals/detail/${proposal.id_encrypt}`;

      return `ステップの担当者になりました　ー<a href="${url}">${proposal.title}</a>`;
    },
    taskAssigned(data) {
      const task = data.task;
      const step = task.step;
      const proposal = step.proposal;
      const url = proposal.is_todo
          ? `/todo/detail/${proposal.id_encrypt}`
          : `/proposals/detail/${proposal.id_encrypt}`;

      return `タスクの担当者になりました　ー<a href="${url}">${proposal.title}</a>`;
    },
    taskCompleted(data) {
      const task = data.task;
      const step = task.step;
      const proposal = step.proposal;
      const url = proposal.is_todo
          ? `/todo/detail/${proposal.id_encrypt}`
          : `/proposals/detail/${proposal.id_encrypt}`;

      return `タスクを実行済みにしました　ー<a href="${url}">${proposal.title}</a>`;
    },

    taskInStepCompleted(data)
    {
      const task = data.task;
      const step = task.step;
      const proposal = step.proposal;
      const url = proposal.is_todo
          ? `/todo/detail/${proposal.id_encrypt}`
          : `/proposals/detail/${proposal.id_encrypt}`;
      const completer = data.completer.full_name;

      return `${completer}がタスクを実行済みにしました　ー<a href="${url}">${proposal.title}</a>`;
    },
    proposalUpdated(data) {
      const proposal = data.proposal;
      const url = proposal.is_todo
          ? `/todo/detail/${proposal.id_encrypt}`
          : `/proposals/detail/${proposal.id_encrypt}`;

      if (proposal.is_todo) {
        return `${proposal.title}を編集しました　ー<a href="${url}">${proposal.title}</a>`;
      }

      return `編集しました　ー<a href="${url}">${proposal.title}</a>`;
    },
    proposalSelfComment(data) {
      const proposal = data.comment.proposal;
      const url = proposal.is_todo
          ? `/todo/detail/${proposal.id_encrypt}`
          : `/proposals/detail/${proposal.id_encrypt}`;

      const content = data.content

      return `コメントをしました：${content}　ー<a href="${url}">${proposal.title}</a>`;
    },
    proposalCommented(data) {
      const proposal = data.comment.proposal;
      const url = proposal.is_todo
          ? `/todo/detail/${proposal.id_encrypt}`
          : `/proposals/detail/${proposal.id_encrypt}`;
      const commenter = data.commenter.full_name;
      const content = data.content

      return `${commenter}がコメントをしました：${content}　ー<a href="${url}">${proposal.title}</a>`;
    },

    weeklyTaskRemind({ countTask }) {
      return `今週${countTask}件のタスクが期限日になっています`;
    },

    dailyTaskRemind(data) {
      const proposal = data.task.step.proposal;
      const url = proposal.is_todo
          ? `/todo/detail/${proposal.id_encrypt}`
          : `/proposals/detail/${proposal.id_encrypt}`;

      return `タスクの期限日です　ー<a href="${url}">${proposal.title}</a>`;
    },

    todoNotifiStartDay(data) {
      const proposal = data.proposal;
      const url = proposal.is_todo
          ? `/todo/detail/${proposal.id_encrypt}`
          : `/proposals/detail/${proposal.id_encrypt}`;

      return `Todoの通知日です　ー<a href="${url}">${proposal.title}</a>`;
    },

    dailyStepRemind(data) {
      const proposal = data.step.proposal;
      const url = proposal.is_todo
          ? `/todo/detail/${proposal.id_encrypt}`
          : `/proposals/detail/${proposal.id_encrypt}`;

      return `ステップの期限日です　ー<a href="${url}">${proposal.title}</a>`;
    },

    saveAsManual(data) {
      const mstProposal = data.mstProposal;
      const url = `/templates/detail/${mstProposal.id_encrypt}`;

      return `テンプレートから<a href="${url}">${mstProposal.title}</a>を作成しました`;
    },

    templateCreated(data) {
      const mstProposal = data.mstProposal;
      const url = `/templates/detail/${mstProposal.id_encrypt}`;

      return `${data.creator.full_name}が<a href="${url}">${mstProposal.title}</a>を作成しました`;
    },

    templateUpdated(data) {
      const { mstProposal, updater } = data;
      const url = `/templates/detail/${mstProposal.id_encrypt}`;

      return `${updater.full_name}が<a href="${url}">${mstProposal.title}</a>を編集しました`;
    },

    templateDeleted(data) {
      const { mstProposal, deleter } = data;

      return `${deleter.full_name}が${mstProposal.title}を削除しました`;
    },

    documentCreated(data) {
      const document = data.document;
      const url = `/document/detail/${document.doc_id}`;

      return `<a href="${url}">${document.name}</a>をアップロードしました`;
    },

    documentUpdated(data) {
      const document = data.document;
      const url = `/document/detail/${document.doc_id}`;

      return `<a href="${url}">${document.name}</a>を編集しました`;
    },

    approveRequestSent(data) {
      const document = data.document;
      const url = `/document/detail/${document.doc_id}`;

      return `${data.sender.full_name}が承認依頼を作成しました　ー<a href="${url}">${document.name}</a>`;
    },

    approveRequestReceived(data) {
      const document = data.document;
      const url = `/document/approve/${data.data.token}?credential_token=${data.data.credential_token}`;
      let txt = 'より承認依頼が届きました　';
      if (data?.urgent) {
        txt = 'より急ぎの承認依頼が届きました';
      }
      return `${data.sender.full_name}${txt}ー<a href="${url}">${document.name}</a>`;
    },

    approveRequestSelfAccept(data) {
      const document = data.document;
      const url = `/document/approve/${data.data.token}?credential_token=${data.data.credential_token}`;

      return `承認依頼を承認しました　ー<a href="${url}">${document.name}</a>`;
    },

    approveRequestSelfReject(data) {
      const document = data.document;
      const url = `/document/approve/${data.data.token}?credential_token=${data.data.credential_token}`;

      return `承認を拒否しました　ー<a href="${url}">${document.name}</a>`;
    },

    approveRequestAccept(data) {
      const document = data.document;
      const url = `/document/detail/${document.doc_id}`;

      return `${data.data.advisorName}が承認依頼を承認しました ー<a href="${url}">${document.name}</a>`;
    },

    approveRequestReject(data) {
      const document = data.document;
      const url = `/document/detail/${document.doc_id}`;

      return `${data.data.advisorName}が承認を拒否しました ー<a href="${url}">${document.name}</a>`;
    },

    documentCompleted(data) {
      const document = data.document;

      return `全ての承認依頼が完了しました ー<a href="${data.data.url}">${document.name}</a>`;
    },

    fileSelfUploaded(data) {
      const document = data.document;
      const url = `/document/approve/${data.data.token}?credential_token=${data.data.credential_token}`;

      return `承認を拒否し、ファイルをアップロードしました　ー<a href="${url}">${document.name}</a>`;
    },

    fileUploaded(data) {
      const document = data.document;
      const url = `/document/checkback/${document.doc_id}/${data.data.id}`;

      return `${data.data.advisorName}が承認を拒否し、ファイルをアップロードしました　ー<a href="${url}">${data.data.filesName.join(', ')}</a>`;
    },

    documentDeleted(data) {
      const document = data.document;

      return `${document.name}を削除しました`;
    },

    documentSelfCommented(data) {
      const document = data.document;
      const url = `/document/detail/${document.doc_id}`;
      const content = data.comment.content

      return `コメントをしました：${content}　ー<a href="${url}">${document.name}</a>`;
    },

    documentCommented(data) {
      const document = data.document;
      const url = `/document/detail/${document.doc_id}`;
      const content = data.comment.content

      return `${data.commenter.full_name}がコメントをしました：${content}　ー<a href="${url}">${document.name}</a>`;
    },

    applicationCreated(data) {
      const url = `/applications/form/${data.applicationUser.id_encrypt}`
      return `<a href="${url}">${data.application.name}</a>を作成しました`
    },

    applicationDeleted(data) {
      return `${data.application.name}を削除しました`
    },

    userInvited(data) {
      return "ユーザーを招待しました";
    },

    userJoined(data) {
      const user = data.user;
      const company = data.company;

      return `${user.full_name}が${company.name}に参加しました`;
    },

    lsProposalCreated(data) {
      const proposal = data.proposal;
      const url = `/proposals/detail/${proposal.id_encrypt}`;

      return `提案が追加されました。提案名：<a href="${url}">${proposal.title}</a>`
    }
  }
}
